/* eslint-disable */
import axios from 'axios';

let db = null;
const dbName = '6gdb';

export default {
  open: function() {
    let resolve, reject;
    const prom = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
  
    const request = indexedDB.open(dbName, 2);

    request.onerror = function() {
      console.error('Database failed to open');
      reject('Database failed to open');
    };

    request.onsuccess = function() {
      db = request.result;
      if (process.env.NODE_ENV != 'development') {
        console.log('Database opened successfully');
      }
      resolve('Database opened successfully');
    };

    request.onupgradeneeded = function() {
      db = request.result;

      if (db.objectStoreNames.contains('keyvalue')) {
        db.deleteObjectStore('keyvalue');
      }

      const objectStore = db.createObjectStore('keyvalue');
      objectStore.createIndex('key', '');
      objectStore.createIndex('value', '');

      resolve('Database opened successfully');
    };

    return prom;
  },
  sizeFormatter: function(size) { // Size in KB
    const sizeName = [ 'bytes', 'KB', 'MB', 'GB' ];

    let currentNameIndex = 0;
    while (size >= 1024) {
      size /= 1024;
      currentNameIndex++;
    }

    return `${size ? size.toFixed(2) : '0'}${sizeName[currentNameIndex] || 'GB'}`;
  },
  getCompanyName: async function() {
    let userParam = window.location.pathname.match(/(u)(\d{1,})/g);
    if (!userParam) {
      return '';
    }

    const userHash = localStorage.getItem(userParam[0]);
    const userDetails = await axios.get(`/Login/GetDetails?key=${userHash}`);
    if (userDetails.data) {
      return userDetails.data.CoRefname || '';
    } else {
      return '';
    }
  },

  set: async function(key, data, expire = 168) { // expire key is in hours | default 168 hours = 7 days
    let resolve;
    const prom = new Promise(res => resolve = res);

    await this.open();
    
    const allKeys = await this.keys();
    
    const compName = await this.getCompanyName();
    const transaction = db.transaction('keyvalue', 'readwrite');
    const objectStore = transaction.objectStore('keyvalue');

    let setRequest;
    const expireDateTime = new Date().setTime(new Date().getTime() + (expire * 60 * 60 * 1000));
    if (allKeys.includes(key)) {
      // Use put if the key exists (for update)
      setRequest = objectStore.put(data, `${compName}_${key}`);
      setRequest = objectStore.put(expireDateTime, `${compName}_${key}_expire`);
    } else {
      // Use add if the key doesn't exists (for new)
      setRequest = objectStore.put(data, `${compName}_${key}`);
      setRequest = objectStore.put(expireDateTime, `${compName}_${key}_expire`);
    }
    // Handles if the add/put has error
    setRequest.onerror = function() {
      console.error("Failed to add data to object store");
      resolve(false);
    };
    // Handles if the add/put success
    setRequest.onsuccess = function() {
      if (process.env.NODE_ENV != 'development') {
        console.log("Data added successfully");
      }
      resolve(true);
    };

    return prom;
  },
  get: async function(key) {
    let resolve;
    const prom = new Promise(res => resolve = res);

    await this.open();
    
    const compName = await this.getCompanyName();
    const transaction = db.transaction('keyvalue', 'readwrite');
    const objectStore = transaction.objectStore('keyvalue');
    
    const getRequest = objectStore.get(`${compName}_${key}`);
    getRequest.onerror = () => {
      console.error(`Error reading key ${key}`);
      resolve(undefined);
    }
    getRequest.onsuccess = (e) => {
      if (e.target.result) {
        resolve(e.target.result);
      } else {
        resolve(undefined);
      }
    }

    return prom;
  },
  delete: async function(key) {
    let resolve;
    const prom = new Promise(res => resolve = res);

    await this.open();
    
    const compName = await this.getCompanyName();
    const transaction = db.transaction('keyvalue', 'readwrite');
    const objectStore = transaction.objectStore('keyvalue');
    
    const deleteRequest = objectStore.delete(`${compName}_${key}`);
    objectStore.delete(`${key}_expire`);
    deleteRequest.onerror = () => {
      console.error(`Error deleting key ${key}`);
      resolve(false);
    }
    deleteRequest.onsuccess = (e) => {
      resolve(true);
    }

    return prom;
  },
  keys: async function() {
    let resolve;
    const prom = new Promise(res => resolve = res);

    await this.open();
    
    const transaction = db.transaction('keyvalue', 'readwrite');
    const objectStore = transaction.objectStore('keyvalue');

    const allKeysRequest = objectStore.getAllKeys();
    allKeysRequest.onerror = () => {
      console.error(`Error getting keys`);
      resolve([]);
    }
    allKeysRequest.onsuccess = (e) => {
      resolve(e.target.result);
    }

    return prom;
  },
  clear: async function() {
    await this.open();

    const allKeys = await this.keys();
    let deleteCount = 0;
    for (let k of allKeys) {
      const deleteSuccess = await this.delete(k);
      if (deleteSuccess) { deleteCount++ }
    }

    if (process.env.NODE_ENV != 'development') {
      console.log(`Deleted ${deleteCount} of ${allKeys.length} keys`);
    }

    return true;
  },
  dbsize: async function() {
    let totalSize = 0;
    const allKeys = Array.from(new Set((await this.keys()).map(k => k.match(/_.*?(_|$)/g).join('').split('_').join(''))));
    for (const k of allKeys) {
      const data = await this.get(k);
      if (data && typeof data == 'object') {
        totalSize += JSON.stringify(data).length;
      } else if (data && typeof data == 'string') {
        totalSize += data.length;
      } else if (data) {
        totalSize += data.toString().length;        
      }
    }

    return { size: totalSize, formatted: this.sizeFormatter(totalSize) };
  },
  removeExpired: async function() {
    const allKeys = await this.keys();
    const allExpireKeys = allKeys.filter(k => k.includes('_expire'));
    const allExpired = [];
    for (const k of allExpireKeys) {
      const expiredValue = await this.get(k);
      if (new Date().getTime() >= expiredValue) {
        allExpired.push(k);
      }
    }

    for (const k of allExpired) {
      await this.delete(k);
      await this.delete(k.replace('_expire', ''));
    }
  },
}
